import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileUp, Loader2 } from 'lucide-react';
import { useDocumentsStore } from '@/stores/documentsStore';

/** The tab's other way in: a requirements document (PDF, markdown, text), read into questions, then a plan. */
export function DocumentUpload() {
  const navigate = useNavigate();
  const input = useRef<HTMLInputElement>(null);
  const upload = useDocumentsStore((s) => s.upload);
  const busy = useDocumentsStore((s) => s.busy.upload ?? false);
  const error = useDocumentsStore((s) => s.uploadError);

  const picked = async (file: File | undefined) => {
    if (file === undefined) return;
    const id = await upload(file);
    if (input.current) input.current.value = '';
    if (id !== null) navigate(`/changes/documents/${id}`);
  };

  return (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border border-dashed border-border bg-card/50 px-4 py-3">
      <input ref={input} type="file" accept=".pdf,.md,.markdown,.txt" className="hidden" onChange={(e) => void picked(e.target.files?.[0])} />
      <button
        onClick={() => input.current?.click()}
        disabled={busy}
        className="inline-flex items-center gap-2 rounded-lg border border-border px-3 py-2 text-sm text-foreground hover:bg-secondary disabled:opacity-50"
      >
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileUp className="h-4 w-4" />} {busy ? 'Uploading…' : 'Start from a document'}
      </button>
      <span className="text-xs text-muted-foreground">A requirements document (PDF, markdown or text, up to 5 MB): ZAC asks what it leaves open, then drafts the plan.</span>
      {error && <span className="w-full text-xs text-red-300">{error}</span>}
    </div>
  );
}
